// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { ConfirmReschedulePaymentPlanInstalmentDTO } from '../models';
import { DeferPaymentPlanInstalmentDTO } from '../models';
import { PaymentPlanInstalmentDTO } from '../models';
import { PaymentPlanInstalmentPayResponseDTO } from '../models';
import { PaymentPlanInstalmentReschedulePreviewDTO } from '../models';
import { ReschedulePaymentPlanInstalmentDTO } from '../models';
/**
 * PaymentPlanInstalmentsApi - axios parameter creator
 * @export
 */
export const PaymentPlanInstalmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Defer a payment plan instalment to a future date
         * @param {string} paymentPlanId Payment plan id
         * @param {string} id Payment plan instalment id
         * @param {DeferPaymentPlanInstalmentDTO} deferPaymentPlanInstalmentDTO body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deferPaymentPlanInstalment(paymentPlanId: string, id: string, deferPaymentPlanInstalmentDTO: DeferPaymentPlanInstalmentDTO, options: any = {}): RequestArgs {
            // verify required parameter 'paymentPlanId' is not null or undefined
            if (paymentPlanId === null || paymentPlanId === undefined) {
                throw new RequiredError('paymentPlanId','Required parameter paymentPlanId was null or undefined when calling deferPaymentPlanInstalment.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deferPaymentPlanInstalment.');
            }
            // verify required parameter 'deferPaymentPlanInstalmentDTO' is not null or undefined
            if (deferPaymentPlanInstalmentDTO === null || deferPaymentPlanInstalmentDTO === undefined) {
                throw new RequiredError('deferPaymentPlanInstalmentDTO','Required parameter deferPaymentPlanInstalmentDTO was null or undefined when calling deferPaymentPlanInstalment.');
            }
            const localVarPath = `/v2/payment-plan/{paymentPlanId}/instalment/{id}/defer`
                .replace(`{${"paymentPlanId"}}`, encodeURIComponent(String(paymentPlanId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"DeferPaymentPlanInstalmentDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(deferPaymentPlanInstalmentDTO !== undefined ? deferPaymentPlanInstalmentDTO : {}) : (deferPaymentPlanInstalmentDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a failed or pending payment plan instalment
         * @param {string} paymentPlanId Payment plan id
         * @param {string} id Payment plan instalment id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePaymentPlanInstalment(paymentPlanId: string, id: string, options: any = {}): RequestArgs {
            // verify required parameter 'paymentPlanId' is not null or undefined
            if (paymentPlanId === null || paymentPlanId === undefined) {
                throw new RequiredError('paymentPlanId','Required parameter paymentPlanId was null or undefined when calling deletePaymentPlanInstalment.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deletePaymentPlanInstalment.');
            }
            const localVarPath = `/v2/payment-plan/{paymentPlanId}/instalment/{id}`
                .replace(`{${"paymentPlanId"}}`, encodeURIComponent(String(paymentPlanId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get payment plan instalment by id
         * @param {string} id Payment plan instalment id
         * @param {string} paymentPlanId Payment plan id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstalmentById(id: string, paymentPlanId: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getInstalmentById.');
            }
            // verify required parameter 'paymentPlanId' is not null or undefined
            if (paymentPlanId === null || paymentPlanId === undefined) {
                throw new RequiredError('paymentPlanId','Required parameter paymentPlanId was null or undefined when calling getInstalmentById.');
            }
            const localVarPath = `/v2/payment-plan/{paymentPlanId}/instalment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"paymentPlanId"}}`, encodeURIComponent(String(paymentPlanId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve payment intent secret for instalment payment
         * @param {string} id Payment plan instalment id
         * @param {string} paymentPlanId Payment plan id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstalmentPaymentIntentSecret(id: string, paymentPlanId: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getInstalmentPaymentIntentSecret.');
            }
            // verify required parameter 'paymentPlanId' is not null or undefined
            if (paymentPlanId === null || paymentPlanId === undefined) {
                throw new RequiredError('paymentPlanId','Required parameter paymentPlanId was null or undefined when calling getInstalmentPaymentIntentSecret.');
            }
            const localVarPath = `/v2/payment-plan/{paymentPlanId}/instalment/{id}/pay`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"paymentPlanId"}}`, encodeURIComponent(String(paymentPlanId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Preview rescheduling a payment plan instalment
         * @param {string} paymentPlanId Payment plan id
         * @param {string} id Payment plan instalment id
         * @param {ReschedulePaymentPlanInstalmentDTO} reschedulePaymentPlanInstalmentDTO body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewReschedulePaymentPlanInstalment(paymentPlanId: string, id: string, reschedulePaymentPlanInstalmentDTO: ReschedulePaymentPlanInstalmentDTO, options: any = {}): RequestArgs {
            // verify required parameter 'paymentPlanId' is not null or undefined
            if (paymentPlanId === null || paymentPlanId === undefined) {
                throw new RequiredError('paymentPlanId','Required parameter paymentPlanId was null or undefined when calling previewReschedulePaymentPlanInstalment.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling previewReschedulePaymentPlanInstalment.');
            }
            // verify required parameter 'reschedulePaymentPlanInstalmentDTO' is not null or undefined
            if (reschedulePaymentPlanInstalmentDTO === null || reschedulePaymentPlanInstalmentDTO === undefined) {
                throw new RequiredError('reschedulePaymentPlanInstalmentDTO','Required parameter reschedulePaymentPlanInstalmentDTO was null or undefined when calling previewReschedulePaymentPlanInstalment.');
            }
            const localVarPath = `/v2/payment-plan/{paymentPlanId}/instalment/{id}/reschedule/preview`
                .replace(`{${"paymentPlanId"}}`, encodeURIComponent(String(paymentPlanId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"ReschedulePaymentPlanInstalmentDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(reschedulePaymentPlanInstalmentDTO !== undefined ? reschedulePaymentPlanInstalmentDTO : {}) : (reschedulePaymentPlanInstalmentDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Reschedule a payment plan instalment
         * @param {string} paymentPlanId Payment plan id
         * @param {string} id Payment plan instalment id
         * @param {ConfirmReschedulePaymentPlanInstalmentDTO} confirmReschedulePaymentPlanInstalmentDTO body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reschedulePaymentPlanInstalment(paymentPlanId: string, id: string, confirmReschedulePaymentPlanInstalmentDTO: ConfirmReschedulePaymentPlanInstalmentDTO, options: any = {}): RequestArgs {
            // verify required parameter 'paymentPlanId' is not null or undefined
            if (paymentPlanId === null || paymentPlanId === undefined) {
                throw new RequiredError('paymentPlanId','Required parameter paymentPlanId was null or undefined when calling reschedulePaymentPlanInstalment.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling reschedulePaymentPlanInstalment.');
            }
            // verify required parameter 'confirmReschedulePaymentPlanInstalmentDTO' is not null or undefined
            if (confirmReschedulePaymentPlanInstalmentDTO === null || confirmReschedulePaymentPlanInstalmentDTO === undefined) {
                throw new RequiredError('confirmReschedulePaymentPlanInstalmentDTO','Required parameter confirmReschedulePaymentPlanInstalmentDTO was null or undefined when calling reschedulePaymentPlanInstalment.');
            }
            const localVarPath = `/v2/payment-plan/{paymentPlanId}/instalment/{id}/reschedule`
                .replace(`{${"paymentPlanId"}}`, encodeURIComponent(String(paymentPlanId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"ConfirmReschedulePaymentPlanInstalmentDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(confirmReschedulePaymentPlanInstalmentDTO !== undefined ? confirmReschedulePaymentPlanInstalmentDTO : {}) : (confirmReschedulePaymentPlanInstalmentDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentPlanInstalmentsApi - functional programming interface
 * @export
 */
export const PaymentPlanInstalmentsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Defer a payment plan instalment to a future date
         * @param {string} paymentPlanId Payment plan id
         * @param {string} id Payment plan instalment id
         * @param {DeferPaymentPlanInstalmentDTO} deferPaymentPlanInstalmentDTO body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deferPaymentPlanInstalment(paymentPlanId: string, id: string, deferPaymentPlanInstalmentDTO: DeferPaymentPlanInstalmentDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = PaymentPlanInstalmentsApiAxiosParamCreator(configuration).deferPaymentPlanInstalment(paymentPlanId, id, deferPaymentPlanInstalmentDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Delete a failed or pending payment plan instalment
         * @param {string} paymentPlanId Payment plan id
         * @param {string} id Payment plan instalment id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePaymentPlanInstalment(paymentPlanId: string, id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = PaymentPlanInstalmentsApiAxiosParamCreator(configuration).deletePaymentPlanInstalment(paymentPlanId, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get payment plan instalment by id
         * @param {string} id Payment plan instalment id
         * @param {string} paymentPlanId Payment plan id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstalmentById(id: string, paymentPlanId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentPlanInstalmentDTO> {
            const localVarAxiosArgs = PaymentPlanInstalmentsApiAxiosParamCreator(configuration).getInstalmentById(id, paymentPlanId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Retrieve payment intent secret for instalment payment
         * @param {string} id Payment plan instalment id
         * @param {string} paymentPlanId Payment plan id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstalmentPaymentIntentSecret(id: string, paymentPlanId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentPlanInstalmentPayResponseDTO> {
            const localVarAxiosArgs = PaymentPlanInstalmentsApiAxiosParamCreator(configuration).getInstalmentPaymentIntentSecret(id, paymentPlanId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Preview rescheduling a payment plan instalment
         * @param {string} paymentPlanId Payment plan id
         * @param {string} id Payment plan instalment id
         * @param {ReschedulePaymentPlanInstalmentDTO} reschedulePaymentPlanInstalmentDTO body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewReschedulePaymentPlanInstalment(paymentPlanId: string, id: string, reschedulePaymentPlanInstalmentDTO: ReschedulePaymentPlanInstalmentDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentPlanInstalmentReschedulePreviewDTO> {
            const localVarAxiosArgs = PaymentPlanInstalmentsApiAxiosParamCreator(configuration).previewReschedulePaymentPlanInstalment(paymentPlanId, id, reschedulePaymentPlanInstalmentDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Reschedule a payment plan instalment
         * @param {string} paymentPlanId Payment plan id
         * @param {string} id Payment plan instalment id
         * @param {ConfirmReschedulePaymentPlanInstalmentDTO} confirmReschedulePaymentPlanInstalmentDTO body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reschedulePaymentPlanInstalment(paymentPlanId: string, id: string, confirmReschedulePaymentPlanInstalmentDTO: ConfirmReschedulePaymentPlanInstalmentDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentPlanInstalmentReschedulePreviewDTO> {
            const localVarAxiosArgs = PaymentPlanInstalmentsApiAxiosParamCreator(configuration).reschedulePaymentPlanInstalment(paymentPlanId, id, confirmReschedulePaymentPlanInstalmentDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PaymentPlanInstalmentsApi - factory interface
 * @export
 */
export const PaymentPlanInstalmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Defer a payment plan instalment to a future date
         * @param {string} paymentPlanId Payment plan id
         * @param {string} id Payment plan instalment id
         * @param {DeferPaymentPlanInstalmentDTO} deferPaymentPlanInstalmentDTO body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deferPaymentPlanInstalment(paymentPlanId: string, id: string, deferPaymentPlanInstalmentDTO: DeferPaymentPlanInstalmentDTO, options?: any) {
            return PaymentPlanInstalmentsApiFp(configuration).deferPaymentPlanInstalment(paymentPlanId, id, deferPaymentPlanInstalmentDTO, options)(axios, basePath);
        },
        /**
         * Delete a failed or pending payment plan instalment
         * @param {string} paymentPlanId Payment plan id
         * @param {string} id Payment plan instalment id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePaymentPlanInstalment(paymentPlanId: string, id: string, options?: any) {
            return PaymentPlanInstalmentsApiFp(configuration).deletePaymentPlanInstalment(paymentPlanId, id, options)(axios, basePath);
        },
        /**
         * Get payment plan instalment by id
         * @param {string} id Payment plan instalment id
         * @param {string} paymentPlanId Payment plan id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstalmentById(id: string, paymentPlanId: string, options?: any) {
            return PaymentPlanInstalmentsApiFp(configuration).getInstalmentById(id, paymentPlanId, options)(axios, basePath);
        },
        /**
         * Retrieve payment intent secret for instalment payment
         * @param {string} id Payment plan instalment id
         * @param {string} paymentPlanId Payment plan id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstalmentPaymentIntentSecret(id: string, paymentPlanId: string, options?: any) {
            return PaymentPlanInstalmentsApiFp(configuration).getInstalmentPaymentIntentSecret(id, paymentPlanId, options)(axios, basePath);
        },
        /**
         * Preview rescheduling a payment plan instalment
         * @param {string} paymentPlanId Payment plan id
         * @param {string} id Payment plan instalment id
         * @param {ReschedulePaymentPlanInstalmentDTO} reschedulePaymentPlanInstalmentDTO body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewReschedulePaymentPlanInstalment(paymentPlanId: string, id: string, reschedulePaymentPlanInstalmentDTO: ReschedulePaymentPlanInstalmentDTO, options?: any) {
            return PaymentPlanInstalmentsApiFp(configuration).previewReschedulePaymentPlanInstalment(paymentPlanId, id, reschedulePaymentPlanInstalmentDTO, options)(axios, basePath);
        },
        /**
         * Reschedule a payment plan instalment
         * @param {string} paymentPlanId Payment plan id
         * @param {string} id Payment plan instalment id
         * @param {ConfirmReschedulePaymentPlanInstalmentDTO} confirmReschedulePaymentPlanInstalmentDTO body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reschedulePaymentPlanInstalment(paymentPlanId: string, id: string, confirmReschedulePaymentPlanInstalmentDTO: ConfirmReschedulePaymentPlanInstalmentDTO, options?: any) {
            return PaymentPlanInstalmentsApiFp(configuration).reschedulePaymentPlanInstalment(paymentPlanId, id, confirmReschedulePaymentPlanInstalmentDTO, options)(axios, basePath);
        },
    };
};

/**
 * PaymentPlanInstalmentsApi - interface
 * @export
 * @interface PaymentPlanInstalmentsApi
 */
export interface PaymentPlanInstalmentsApiInterface {
    /**
     * Defer a payment plan instalment to a future date
     * @param {string} paymentPlanId Payment plan id
     * @param {string} id Payment plan instalment id
     * @param {DeferPaymentPlanInstalmentDTO} deferPaymentPlanInstalmentDTO body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlanInstalmentsApiInterface
     */
    deferPaymentPlanInstalment(paymentPlanId: string, id: string, deferPaymentPlanInstalmentDTO: DeferPaymentPlanInstalmentDTO, options?: any): AxiosPromise<object>;

    /**
     * Delete a failed or pending payment plan instalment
     * @param {string} paymentPlanId Payment plan id
     * @param {string} id Payment plan instalment id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlanInstalmentsApiInterface
     */
    deletePaymentPlanInstalment(paymentPlanId: string, id: string, options?: any): AxiosPromise<object>;

    /**
     * Get payment plan instalment by id
     * @param {string} id Payment plan instalment id
     * @param {string} paymentPlanId Payment plan id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlanInstalmentsApiInterface
     */
    getInstalmentById(id: string, paymentPlanId: string, options?: any): AxiosPromise<PaymentPlanInstalmentDTO>;

    /**
     * Retrieve payment intent secret for instalment payment
     * @param {string} id Payment plan instalment id
     * @param {string} paymentPlanId Payment plan id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlanInstalmentsApiInterface
     */
    getInstalmentPaymentIntentSecret(id: string, paymentPlanId: string, options?: any): AxiosPromise<PaymentPlanInstalmentPayResponseDTO>;

    /**
     * Preview rescheduling a payment plan instalment
     * @param {string} paymentPlanId Payment plan id
     * @param {string} id Payment plan instalment id
     * @param {ReschedulePaymentPlanInstalmentDTO} reschedulePaymentPlanInstalmentDTO body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlanInstalmentsApiInterface
     */
    previewReschedulePaymentPlanInstalment(paymentPlanId: string, id: string, reschedulePaymentPlanInstalmentDTO: ReschedulePaymentPlanInstalmentDTO, options?: any): AxiosPromise<PaymentPlanInstalmentReschedulePreviewDTO>;

    /**
     * Reschedule a payment plan instalment
     * @param {string} paymentPlanId Payment plan id
     * @param {string} id Payment plan instalment id
     * @param {ConfirmReschedulePaymentPlanInstalmentDTO} confirmReschedulePaymentPlanInstalmentDTO body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlanInstalmentsApiInterface
     */
    reschedulePaymentPlanInstalment(paymentPlanId: string, id: string, confirmReschedulePaymentPlanInstalmentDTO: ConfirmReschedulePaymentPlanInstalmentDTO, options?: any): AxiosPromise<PaymentPlanInstalmentReschedulePreviewDTO>;

}

/**
 * PaymentPlanInstalmentsApi - object-oriented interface
 * @export
 * @class PaymentPlanInstalmentsApi
 * @extends {BaseAPI}
 */
export class PaymentPlanInstalmentsApi extends BaseAPI implements PaymentPlanInstalmentsApiInterface {
    /**
     * Defer a payment plan instalment to a future date
     * @param {string} paymentPlanId Payment plan id
     * @param {string} id Payment plan instalment id
     * @param {DeferPaymentPlanInstalmentDTO} deferPaymentPlanInstalmentDTO body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlanInstalmentsApi
     */
    public deferPaymentPlanInstalment(paymentPlanId: string, id: string, deferPaymentPlanInstalmentDTO: DeferPaymentPlanInstalmentDTO, options?: any) {
        return PaymentPlanInstalmentsApiFp(this.configuration).deferPaymentPlanInstalment(paymentPlanId, id, deferPaymentPlanInstalmentDTO, options)(this.axios, this.basePath);
    }

    /**
     * Delete a failed or pending payment plan instalment
     * @param {string} paymentPlanId Payment plan id
     * @param {string} id Payment plan instalment id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlanInstalmentsApi
     */
    public deletePaymentPlanInstalment(paymentPlanId: string, id: string, options?: any) {
        return PaymentPlanInstalmentsApiFp(this.configuration).deletePaymentPlanInstalment(paymentPlanId, id, options)(this.axios, this.basePath);
    }

    /**
     * Get payment plan instalment by id
     * @param {string} id Payment plan instalment id
     * @param {string} paymentPlanId Payment plan id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlanInstalmentsApi
     */
    public getInstalmentById(id: string, paymentPlanId: string, options?: any) {
        return PaymentPlanInstalmentsApiFp(this.configuration).getInstalmentById(id, paymentPlanId, options)(this.axios, this.basePath);
    }

    /**
     * Retrieve payment intent secret for instalment payment
     * @param {string} id Payment plan instalment id
     * @param {string} paymentPlanId Payment plan id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlanInstalmentsApi
     */
    public getInstalmentPaymentIntentSecret(id: string, paymentPlanId: string, options?: any) {
        return PaymentPlanInstalmentsApiFp(this.configuration).getInstalmentPaymentIntentSecret(id, paymentPlanId, options)(this.axios, this.basePath);
    }

    /**
     * Preview rescheduling a payment plan instalment
     * @param {string} paymentPlanId Payment plan id
     * @param {string} id Payment plan instalment id
     * @param {ReschedulePaymentPlanInstalmentDTO} reschedulePaymentPlanInstalmentDTO body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlanInstalmentsApi
     */
    public previewReschedulePaymentPlanInstalment(paymentPlanId: string, id: string, reschedulePaymentPlanInstalmentDTO: ReschedulePaymentPlanInstalmentDTO, options?: any) {
        return PaymentPlanInstalmentsApiFp(this.configuration).previewReschedulePaymentPlanInstalment(paymentPlanId, id, reschedulePaymentPlanInstalmentDTO, options)(this.axios, this.basePath);
    }

    /**
     * Reschedule a payment plan instalment
     * @param {string} paymentPlanId Payment plan id
     * @param {string} id Payment plan instalment id
     * @param {ConfirmReschedulePaymentPlanInstalmentDTO} confirmReschedulePaymentPlanInstalmentDTO body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlanInstalmentsApi
     */
    public reschedulePaymentPlanInstalment(paymentPlanId: string, id: string, confirmReschedulePaymentPlanInstalmentDTO: ConfirmReschedulePaymentPlanInstalmentDTO, options?: any) {
        return PaymentPlanInstalmentsApiFp(this.configuration).reschedulePaymentPlanInstalment(paymentPlanId, id, confirmReschedulePaymentPlanInstalmentDTO, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for PaymentPlanInstalmentsApi
 * Import individual functions for optimal bundle size
 */
/**
 * Defer a payment plan instalment to a future date
 * @param {string} paymentPlanId Payment plan id
 * @param {string} id Payment plan instalment id
 * @param {DeferPaymentPlanInstalmentDTO} deferPaymentPlanInstalmentDTO body
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function deferPaymentPlanInstalment(
    paymentPlanId: string,
    id: string,
    deferPaymentPlanInstalmentDTO: DeferPaymentPlanInstalmentDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = PaymentPlanInstalmentsApiAxiosParamCreator(configuration).deferPaymentPlanInstalment(paymentPlanId, id, deferPaymentPlanInstalmentDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Delete a failed or pending payment plan instalment
 * @param {string} paymentPlanId Payment plan id
 * @param {string} id Payment plan instalment id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function deletePaymentPlanInstalment(
    paymentPlanId: string,
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = PaymentPlanInstalmentsApiAxiosParamCreator(configuration).deletePaymentPlanInstalment(paymentPlanId, id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get payment plan instalment by id
 * @param {string} id Payment plan instalment id
 * @param {string} paymentPlanId Payment plan id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getInstalmentById(
    id: string,
    paymentPlanId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<PaymentPlanInstalmentDTO> {
    const localVarAxiosArgs = PaymentPlanInstalmentsApiAxiosParamCreator(configuration).getInstalmentById(id, paymentPlanId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Retrieve payment intent secret for instalment payment
 * @param {string} id Payment plan instalment id
 * @param {string} paymentPlanId Payment plan id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getInstalmentPaymentIntentSecret(
    id: string,
    paymentPlanId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<PaymentPlanInstalmentPayResponseDTO> {
    const localVarAxiosArgs = PaymentPlanInstalmentsApiAxiosParamCreator(configuration).getInstalmentPaymentIntentSecret(id, paymentPlanId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Preview rescheduling a payment plan instalment
 * @param {string} paymentPlanId Payment plan id
 * @param {string} id Payment plan instalment id
 * @param {ReschedulePaymentPlanInstalmentDTO} reschedulePaymentPlanInstalmentDTO body
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function previewReschedulePaymentPlanInstalment(
    paymentPlanId: string,
    id: string,
    reschedulePaymentPlanInstalmentDTO: ReschedulePaymentPlanInstalmentDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<PaymentPlanInstalmentReschedulePreviewDTO> {
    const localVarAxiosArgs = PaymentPlanInstalmentsApiAxiosParamCreator(configuration).previewReschedulePaymentPlanInstalment(paymentPlanId, id, reschedulePaymentPlanInstalmentDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Reschedule a payment plan instalment
 * @param {string} paymentPlanId Payment plan id
 * @param {string} id Payment plan instalment id
 * @param {ConfirmReschedulePaymentPlanInstalmentDTO} confirmReschedulePaymentPlanInstalmentDTO body
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function reschedulePaymentPlanInstalment(
    paymentPlanId: string,
    id: string,
    confirmReschedulePaymentPlanInstalmentDTO: ConfirmReschedulePaymentPlanInstalmentDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<PaymentPlanInstalmentReschedulePreviewDTO> {
    const localVarAxiosArgs = PaymentPlanInstalmentsApiAxiosParamCreator(configuration).reschedulePaymentPlanInstalment(paymentPlanId, id, confirmReschedulePaymentPlanInstalmentDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

